<app-page-detail [id]="id" [crud]="service" [(model)]="model" [(form)]="form" [reload]="reload" (modelChange)="checkModelGeneric($event)">
  <ng-container *ngIf="model()">
  <div class="flex flex-column md:flex-row gap-3 w-full justify-content-around p-3">
    <app-editable-card title="Dati del prelievo" class="md:w-4" style="border-radius: 0.5rem !important;" [(model)]="model" [form]="formGeneric" [crud]="serviceUpdate" >
      <app-text-field label="Codice Prelievo" [value]="model().prelievo.codicePrelievo"></app-text-field>
      <app-text-field label="Ente Prelievo" [value]="model().prelievo.entePrelievo"></app-text-field>
      <app-text-field label="Controllo Esterno" [value]="model().controlloEsterno ? 'SI' : 'NO'"></app-text-field>
      <app-text-field label="controllo Extra Piano" [value]="model().controlloExtraPiano ? 'SI' : 'NO'"></app-text-field>
      <app-text-field label="Data e ora" [value]="model().prelievo.dataOraPrelievo | date:'dd-MM-yy HH:MM'"></app-text-field>
      <app-text-field label="Data" [value]="model().prelievo.dataOraPrelievo  | date:'dd-MM-yy'"></app-text-field>
      <app-text-field label="Ora" [value]="model().prelievo.dataOraPrelievo | date:'HH:MM'"></app-text-field>
      <div card-form>
        <div class="flex flex-column md:flex-row gap-3" [formGroup]="formGeneric"  *ngIf="prelievoControl">
          <app-input-text label="Codice Prelievo" name="codicePrelievo" [form]="prelievoControl" style="margin-bottom: 30px;"></app-input-text>
          <app-input-text label="Codice Prelievo" name="entePrelievo" [form]="prelievoControl" style="margin-bottom: 30px;"></app-input-text>
          <app-input-datetime label="Data Ora Prelievo" name="dataOraPrelievo" [form]="prelievoControl"  [minDate]="model().puntoCampionamento.dataInizioValidita" [maxDate]="model().puntoCampionamento.dataFineValidita"></app-input-datetime>
          <app-input-toggle name="controlloEsterno" [form]="prelievoControl" label="Controllo esterno"></app-input-toggle>
          <app-input-toggle name="controlloExtraPiano" [form]="prelievoControl" label="Controllo Extra Piano"></app-input-toggle>
        </div>
      </div>
    </app-editable-card>
    <div class="flex flex-column align-items-center justify-content-center border-1 surface-border border-round px-2 py-1 bg-white">
      <div class="text-sm text-700 font-light">
        Errori
      </div>

      <div *ngIf="formGeneric.valid" class="text-sm text-700 font-light">
        il form è valido: 

        <mat-icon  class="mat-mdc-tooltip-trigger text-green-400 material-symbols-outlined" style="position: relative; top:7px">check</mat-icon>
    
      </div>

      <div *ngIf="!formGeneric.valid && this.errorMessage" class="text-sm text-700 font-light">
        il form non è valido, dettaglio degli errori: 

          <mat-icon  class="mat-mdc-tooltip-trigger text-red-400 material-symbols-outlined" style="position: relative; top:7px;cursor: pointer;" (click)="showDialog()">error</mat-icon>
    
      </div>

    </div>
    <app-editable-card title="Dati dell'analisi" class="md:w-4" style="border-radius: 0.5rem !important;" [(model)]="model" [form]="formGeneric" [crud]="serviceUpdate">
      <app-text-field label="Codice" [value]="model().analisi.codiceAccrediaLaboratorioAnalisi"></app-text-field>
      <app-text-field label="Data" [value]="model().analisi.dataOraAnalisi   | date:'dd-MM-yy'"></app-text-field>
      <app-text-field label="Ora" [value]="model().analisi.dataOraAnalisi  | date:'HH:MM'"></app-text-field>
      <app-text-field label="Numero Rapporto" [value]="model().analisi.numeroRapportoProvaAnalisi"></app-text-field>
      <div card-form>
        <div class="" [formGroup]="formGeneric" *ngIf="analisiControl">
          <app-input-text label="Codice Analisi" name="codiceAccrediaLaboratorioAnalisi" [form]="analisiControl" style="margin-bottom: 30px;"></app-input-text>
          <app-input-text label="Codice Analisi" name="numeroRapportoProvaAnalisi" [form]="analisiControl" style="margin-bottom: 30px;"></app-input-text>
          <app-input-datetime label="Data Ora Analisi" name="dataOraAnalisi" [form]="analisiControl"   [minDate]="prelievoControl.get('dataOraPrelievo')?.value" [maxDate]="model().puntoCampionamento.dataFineValidita"></app-input-datetime>
        </div>
      </div>
    </app-editable-card>
  </div>
  <div class="flex flex-column md:flex-row gap-3 w-full justify-content-center p-3">
    <app-card title="Parametri" class="md:w-12" style="   max-height:50vh;overflow: auto;border-radius: 0.5rem !important;">
<!--      <div *ngFor="let item of model().dati">
        <app-text-field label="Definizione" [value]="item.parametro.definizione"></app-text-field>
        <app-text-field label="Valore" [value]="item.valore"></app-text-field>
        <app-text-field label="Precisione Minima" [value]="item.parametro.precisioneMinima"></app-text-field>
        <app-text-field label="Unità di Misura"  [value]="item.parametro.unitaDiMisura"></app-text-field>
        <app-text-field label="Obbligatori" [value]="item.parametro.obbligatorio  ? 'SI' : 'NO'"></app-text-field>
        <app-text-field label="Note"  [value]="item.parametro.note"></app-text-field>
        <div class="flex flex-row ">
          <app-text-field label="Status" ></app-text-field>
          <mat-icon class="mat-mdc-tooltip-trigger text-{{statusDefaultTextColor[item.status]}}-400 material-symbols-outlined">{{statusDefaultIcon[item.status]}}</mat-icon>
        </div>
        <hr>
      </div>  -->
      <div class="flex justify-content-end">
        <div>
            <app-button label="Aggiungi Parametri al Controllo" icon="add" (click)="showDialogParametriInsert()" raised fullWidth cdkFocusRegionstart></app-button>
        </div>
        
      </div>
      <app-table *ngIf="modelTable" matSort [data]="modelTable" [crud]="servicePrelievo" [columns]="columnsParametriAlert"
       [showButtonInsert]="true" 
       typeIconInsert="edit" 
       [costumSaveFuction]="costumSaveFuction" 
       [IsSaveFuction]="true" 
       typeTitleInsert="Modifica Valore" 
       [insertForm]="formUpdate" 
       (myDataEvent)="checkDataRow($event)"
       [reload]="reload">
        <div insert-form class="flex flex-column gap-2">
          <form *ngIf="formUpdate" [formGroup]="formUpdate"> 
            <div  class="col-12 md:col-12 lg:col-12" *ngIf="item" style="padding:0px;margin-bottom:10px">
              <mat-form-field  *ngIf="item?.tipologia=='chimico_fisico' || item?.tipologia=='antiparassitario'">
                <mat-label>Loq</mat-label>
                <mat-select  formControlName="valoreLoq"  (selectionChange)="toFormGroup(formUpdate)">
                  <mat-option value=""></mat-option>
                  <mat-option value="<"><</mat-option>
                </mat-select>
              </mat-form-field>
              <mat-form-field  *ngIf="item?.tipologia=='microbiologico'" >
                <mat-label>Lsf</mat-label>
                <mat-select  formControlName="valoreLfs"  (selectionChange)="toFormGroup(formUpdate)">
                  <mat-option value=""></mat-option>
                  <mat-option value=">">></mat-option>
                </mat-select>
              </mat-form-field>
            </div>
       
            <div  class="col-12 md:col-12 lg:col-12" *ngIf="item" style="padding:0px;margin-bottom:10px">
              <app-input-number name="valoreArrotondato"  *ngIf="item?.tipologia!='qualitativo'"   placeholder="Valore Arrotondato" [form]="formUpdate"></app-input-number>
              <app-input-number name="valoreRapportoProva"  *ngIf="((item?.tipologia=='chimico_fisico' || item?.tipologia=='antiparassitario') && formUpdate.get('valoreLoq')?.value==null) || (item?.tipologia=='microbiologico' && formUpdate.get('valoreLfs')?.value==null)"   placeholder="Valore Rapporto Prova" [form]="formUpdate"></app-input-number>
              <!--nel caso si trattasse di parametri tipo chimico fisico antiparassitario con loq < -->
              <app-input-number 
              name="loq" 
              *ngIf="((item?.tipologia == 'chimico_fisico' && formUpdate.get('valoreLoq')?.value == '<') || 
                      (item?.tipologia == 'antiparassitario' && formUpdate.get('valoreLoq')?.value == '<'))" 
              placeholder="Valore Loq" 
              [form]="formUpdate">
            </app-input-number>
              <!--nel caso si trattasse di parametri tipo microbiologico con lsf > -->
              <app-input-number name="lfs"  *ngIf="(item?.tipologia=='microbiologico' && formUpdate.get('valoreLfs')?.value=='>')"   placeholder="Valore Lfs" [form]="formUpdate"></app-input-number>
              <!--nel caso si trattasse di parametri tipo odore-->
              <mat-form-field  *ngIf="item?.tipologia=='qualitativo'" >
                <mat-label>valore</mat-label>
                <mat-select  formControlName="valoreRapportoProva"  (selectionChange)="toFormGroup(formUpdate)">
                  <mat-option [value]="0">NO</mat-option>
                  <mat-option [value]="1">SI</mat-option>
                </mat-select>
              </mat-form-field>
            </div>
            <div  class="col-12 md:col-12 lg:col-12" style="padding:0px;margin-bottom:10px" >
              <app-input-text name="incertezza"   placeholder="Incertezza" [form]="formUpdate"></app-input-text>
            </div>
            <div  class="col-12 md:col-12 lg:col-12" style="padding:0px;margin-bottom:10px">
              <app-input-text name="metodo"   placeholder="Metodo" [form]="formUpdate"></app-input-text>
            </div>
          </form>

          </div>
      </app-table>
    </app-card>
  </div>

</ng-container>
</app-page-detail>
